module.exports = __webpack_public_path__ + "static/media/health.51451692.png";